'use client';

import dynamic from 'next/dynamic';

import classNames from 'classnames';

import { ExternalLink } from '@uikit';

import { ArrowRight2 } from '@uikit/icons/ArrowRight2';
import LinkIcon from '@uikit/icons/Link';

import { ADS_CONSTANTS, useUserAdSettings } from '@shared/common/components/NavLayout/AdBlocks';
import NextLink from '@shared/common/components/NextLink';

import { useWatchBuyEntries } from '@store:web/components/entities/rewardPool';

import { ActiveRaffles } from './segments/ActiveRaffles';
import { AllPools } from './segments/AllPools/AllPools';
import { FeaturedAndDailyPools } from './segments/FeaturedAndDailyPools';
import { Stats } from './segments/Stats';

const StoreMainInlineTopBannerTextButton = dynamic(
  () => import('@shared/common/components/NavLayout/AdBlocks/StoreMainInlineTopBannerTextButton'),
  {
    ssr: false,
  },
);

export const RewardPoolsPage = () => {
  const { showStoreMainInlineTopBannerTextButton } = useUserAdSettings();

  const title = 'Reward Pools';

  useWatchBuyEntries({ type: 'list' });

  return (
    <>
      <div className="relative">
        <div className="absolute w-full top-0 left-0 h-56 gradient-page -z-[1]" />
        <StoreMainInlineTopBannerTextButton
          dataKey={ADS_CONSTANTS.storeMainInlineTopBannerTextButtonDataKey}
        />
        <main
          className={classNames('msq-container', {
            'pt-4': showStoreMainInlineTopBannerTextButton,
          })}
        >
          <nav
            aria-label="Breadcrumb"
            className="breadcrumbs breadcrumbs-sm mb-2 xl:mb-1 xl:breadcrumbs-md"
          >
            <NextLink href="/" className="breadcrumbs-link">
              Discover
            </NextLink>
            <ArrowRight2 aria-hidden="true" className="breadcrumbs-separator" />
            <NextLink href="/reward-pools" className="breadcrumbs-link" aria-current="page">
              {title}
            </NextLink>
          </nav>

          <header className="flex max-xl:flex-col xl:items-center xl:justify-between gap-4 mb-6 xl:mb-8">
            <h1 className="text-[2.5rem] leading-[1.2] font-semibold ">{title}</h1>

            <ExternalLink
              href="https://docs.magicsquare.io/for-users/reward-pools"
              className="msq-btn msq-btn-md msq-btn-secondary max-xl:w-full"
            >
              How it Works
              <LinkIcon className="msq-btn-icon-child msq-btn-icon-child-right" />
            </ExternalLink>
          </header>

          <Stats />

          <FeaturedAndDailyPools />
          <ActiveRaffles />
          <AllPools />
        </main>
      </div>
    </>
  );
};
